import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type collectionTrialModalQuery,
} from './__generated__/collectionTrialModalQuery.graphql';

export type EntryPointParams = {
	collectionEntitlementId: string;
};

type CollectionTrialModalComponent = EntryPointComponent<
	{
		collectionTrialModalQuery: collectionTrialModalQuery;
	},
	Record<string, never>,
	{
		onClose: (extraInformation?: unknown) => void;
	},
	Record<string, never>
>;

export const entryPoint: EntryPoint<CollectionTrialModalComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForInteraction<CollectionTrialModalComponent>(
			/* webpackChunkName: "@atlaskit-internal_edition-awareness-collection-trial-modal" */ './collection-trial-modal',
			{
				moduleId: 'edition-awareness-collection-trial-modal',
			},
		),
		getPreloadProps: ({ collectionEntitlementId }: EntryPointParams) => ({
			entryPoints: {},
			extraProps: {},
			queries: {
				collectionTrialModalQuery: {
					parameters,
					variables: {
						collectionEntitlementId,
					},
				},
			},
		}),
	});
